import { ButtonType } from '@systemeio/ui'
import { ActionButtonBaseProps } from 'modules/stores/store/components/item-actions'
import { FC, PropsWithChildren } from 'react'

interface ActionButtonProps extends ActionButtonBaseProps {
  ButtonComponent: FC<ButtonType>
}

export const ActionButton: FC<PropsWithChildren<ActionButtonProps>> = ({
  ButtonComponent,
  onClick,
  isFetching,
  disabled,
  children,
}) => {
  return onClick ? (
    <ButtonComponent onClick={onClick} disabled={disabled} isFetching={isFetching}>
      {children}
    </ButtonComponent>
  ) : null
}
